import { render } from "./SerialStart.vue?vue&type=template&id=b63770dc"
import script from "./SerialStart.vue?vue&type=script&lang=js"
export * from "./SerialStart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__